import { CommonModule } from '@angular/common';
import { Component,Inject } from '@angular/core';
import { FormControl,FormGroup,FormsModule,ReactiveFormsModule,Validators } from '@angular/forms';

import { CdkDrag,CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatLegacyDialogConfig,MatLegacyDialogModule,MatLegacyDialogRef,MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MathScope } from 'mathjs';
import { AppButtonModule } from '../../dave-utils-module/app-button-module/app-button.module';
import { appMatDialogDefaultConfig } from '../../helper/helper';
import * as mjsHelper from '../../helper/math-js-helper';
import { duplicationValidator,getErrorMessage } from '../../helper/validation.helper';
import { CalculationInputResultComponent } from '../calculation-input-result/calculation-input-result.component';

export interface CalculationVariableModalDialogData {
    maxDecimalPlaces: number;
    mathScope: MathScope;
    initialValues?: {
        description: string;
        formula: string;
        key: string;
    };
}

export interface CalculationVariableModalDialogReturnData {
    description: string;
    formula: string;
    key: string;
    result: number | null;
    resultRounded: number | null;
    deleted: boolean;
}
@Component({
    selector: 'app-aclculation-variable-modal',
    standalone: true,
    imports: [
        CommonModule,
        MatLegacyInputModule,
        ReactiveFormsModule,
        FormsModule,
        AppButtonModule,
        MatLegacyDialogModule,
        MatLegacyDialogModule,
        MatLegacyInputModule,
        CalculationInputResultComponent,
        FontAwesomeModule,
        CdkDrag,
        CdkDragHandle,
    ],
    templateUrl: './calculation-variable-modal.component.html',
    styleUrls: ['./calculation-variable-modal.component.scss'],
})
export class CalculationVariableModalComponent {
    public static DefaultConfig: MatLegacyDialogConfig = {
        ...appMatDialogDefaultConfig,
        hasBackdrop: false,
        autoFocus: 'first-tabbable',
        delayFocusTrap: true,
        width: '30rem',
    };
    protected form: FormGroup<{
        description: FormControl<string>;
        formula: FormControl<string>;
        key: FormControl<string>;
    }>;
    protected readonly maxDecimalPlaces: number;
    protected readonly scope: MathScope;
    protected readonly headline: string;
    protected readonly canDelete: boolean;
    constructor(@Inject(MAT_LEGACY_DIALOG_DATA) data: CalculationVariableModalDialogData, private dialogRef: MatLegacyDialogRef<CalculationVariableModalComponent, CalculationVariableModalDialogReturnData>) {
        this.headline = data.initialValues ? 'Parameter bearbeiten' : 'Parameter anlegen';
        this.canDelete = !!data.initialValues;
        this.maxDecimalPlaces = data.maxDecimalPlaces;
        this.scope = data.mathScope;
        const notAllowedVariableNames = Array.from(this.scope.keys()).filter((k) => k !== data.initialValues?.key);
        this.form = new FormGroup({
            description: new FormControl<string>(data.initialValues?.description),
            formula: new FormControl<string>(data.initialValues?.formula, { validators: [Validators.required] }),
            key: new FormControl<string>(data.initialValues?.key, {
                validators: [
                    Validators.required,
                    Validators.pattern(/^[a-zA-Z_äöüÄÖÜß]+$/),
                    Validators.minLength(1),
                    /*Validators.maxLength(20),*/
                    duplicationValidator(notAllowedVariableNames),
                ],
            }),
        });
    }
    close() {
        const r = mjsHelper.evaluate(this.form.controls.formula.value, this.maxDecimalPlaces, this.scope);
        this.dialogRef.close({
            result: r.invalid ? null : r.res,
            resultRounded: r.invalid ? null : r.resRounded,
            formula: this.form.controls.formula.value,
            description: this.form.controls.description.value,
            key: this.form.controls.key.value,
            deleted: false,
        });
    }
    getErrorMessage(control: FormControl<any>) {
        if (control.valid) {
            return null;
        }
        if (control.hasError('duplicate')) {
            return 'Variable ist bereits vorhanden';
        }
        return getErrorMessage(control);
    }
}
